import React from 'react';
import { FormattedMarkdown } from '@/components/formatted-markdown';
import { KeyboardAwareScrollView } from '@/components/with-keyboard-aware';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

interface Props {
  markdownTemplate: string;
}

export const PadAdditionalTerms: React.FC<Props> = ({ markdownTemplate }) => {
  const { bottom } = useSafeAreaInsets();

  return (
    <View style={styles.container}>
      <KeyboardAwareScrollView
        contentContainerStyle={[{ paddingBottom: bottom + 80 }]}
        keyboardDismissMode="on-drag"
        style={styles.contentContainer}
      >
        <View style={styles.contentWrapper}>
          <View style={styles.termsBox}>
            <FormattedMarkdown markdown={markdownTemplate} />
          </View>
        </View>
      </KeyboardAwareScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  contentContainer: {
    flex: 1,
  },
  contentWrapper: {
    paddingHorizontal: 16,
  },
  termsBox: {
    borderRadius: 8,
    padding: 16,
  },
});
